import React from 'react';

const getPixelSize = (size) => {
    if (typeof size === 'number') return Math.max(12, size);
    if (size === 'small') return 20;
    if (size === 'large') return 40;
    return 32;
};

const LoadingSpinner = ({
    text = 'Loading...',
    variant = 'card',
    size = 'medium',
    showText = true,
    fullWidth = true
}) => {
    const pixelSize = getPixelSize(size);

    const wrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: fullWidth ? '100%' : 'auto'
    };

    if (variant === 'page') {
        wrapperStyles.minHeight = '45vh';
        wrapperStyles.padding = '2rem 1rem';
    }

    const bodyStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        boxSizing: 'border-box'
    };

    if (variant === 'card') {
        bodyStyles.padding = '2rem 2.5rem';
        bodyStyles.background = '#ffffff';
        bodyStyles.borderRadius = '14px';
        bodyStyles.border = '1px solid #e2e8f0';
        bodyStyles.boxShadow = '0 8px 24px rgba(43, 70, 99, 0.12)';
        bodyStyles.maxWidth = '100%';
    }

    const spinnerStyles = {
        width: `${pixelSize}px`,
        height: `${pixelSize}px`,
        border: `${Math.max(2, Math.round(pixelSize / 10))}px solid #dbe6f3`,
        borderTop: `${Math.max(2, Math.round(pixelSize / 10))}px solid #2b6cb0`,
        borderRadius: '50%',
        animation: 'copilot-shared-spin 0.9s linear infinite',
        flexShrink: 0,
        marginBottom: showText ? '0.8rem' : 0
    };

    const textStyles = {
        color: '#64748b',
        fontSize: '0.95rem',
        margin: 0,
        fontWeight: 600,
        maxWidth: '100%'
    };

    return (
        <div style={wrapperStyles}>
            <div style={bodyStyles}>
                <div style={spinnerStyles} aria-hidden="true" />
                {showText && <p style={textStyles}>{text}</p>}
                <style>{`
                    @keyframes copilot-shared-spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
    );
};

export default LoadingSpinner;